'use client';

import React, { useMemo, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';

const ClearAllFiltersButtonComponent = () => {
  const {
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange,
    selectedColors,
    clearSelectedColors,
    updateTypeFilter,
    selectedFacets,
    clearSelectedFacets,
  } = useAdvancedSearchContext();

  const { items, refine } = useRefinementList({ attribute: 'type' });

  const { items: colorItems, refine: refineColor } = useRefinementList({
    attribute: 'option_color',
  });

  const hasActiveProductTypes = useMemo(
    () => items?.some(item => item.isRefined) || false,
    [items]
  );

  const hasActiveWidth = useMemo(() => !!(minWidth || maxWidth), [
    minWidth,
    maxWidth,
  ]);

  const hasActiveColors = useMemo(
    () =>
      colorItems?.some(item => item.isRefined) ||
      Object.values(selectedColors || {}).some(Boolean),
    [colorItems, selectedColors]
  );

  const hasActiveFacets = useMemo(
    () => selectedFacets && Object.keys(selectedFacets).length > 0,
    [selectedFacets]
  );

  const hasActiveFilters = useMemo(
    () =>
      isReadyToShipActive ||
      hasActiveWidth ||
      hasActiveProductTypes ||
      hasActiveColors ||
      hasActiveFacets,
    [
      isReadyToShipActive,
      hasActiveWidth,
      hasActiveProductTypes,
      hasActiveColors,
      hasActiveFacets,
    ]
  );

  const handleClearAll = useCallback(() => {
    if (isReadyToShipActive) {
      handleToggleReadyToShip?.(false);
    }

    if (hasActiveWidth) {
      handleWidthChange?.('', '');
    }

    if (hasActiveProductTypes) {
      refine([]);
      updateTypeFilter?.(null);
    }

    if (hasActiveColors) {
      colorItems
        ?.filter(item => item.isRefined)
        .forEach(item => refineColor(item.label));
      clearSelectedColors?.();
    }

    if (hasActiveFacets) {
      clearSelectedFacets?.();
    }
  }, [
    isReadyToShipActive,
    handleToggleReadyToShip,
    hasActiveWidth,
    handleWidthChange,
    hasActiveProductTypes,
    refine,
    updateTypeFilter,
    hasActiveColors,
    colorItems,
    refineColor,
    clearSelectedColors,
    hasActiveFacets,
    clearSelectedFacets,
  ]);

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div className="md:pb-5">
      <ClearAllFiltersButton onClick={handleClearAll}>
        Clear all
      </ClearAllFiltersButton>
    </div>
  );
};

export default ClearAllFiltersButtonComponent;
